module.exports = __webpack_public_path__ + "static/media/timeIcon.a3d4f76d.svg";